<template>
    <div class="app">
        <AppHeader fixed>
            <SidebarToggler class="d-lg-none" display="md" mobile />
            <b-link class="navbar-brand" to="/admin/home">
                <div class="navbar-brand-full ml-2">
                    <img src="img/logo_white.png" width="auto" height="90%" alt="Logo" />
                    <div class="title">
                        <p class="mcst">
                            MINISTRY OF CULTURE, SPORTS AND TOURISM
                        </p>
                        <p class="vnat bold">
                            VIETNAM NATIONAL ADMINISTRATION OF TOURISM
                        </p>
                    </div>
                    <div class="certificate">
                        <div style="max-width: 22px;margin-right: 15px;">
                            <img src="img/icon_certificate.png" width="100%" height="100%" alt="Logo" />
                        </div>
                        <div class="certificate-title">
                            <p class="text">
                               COVID-19 Vaccination Certificate
                            </p>
                        </div>
                    </div>
                </div>
                <div class="navbar-brand-minimized ml-2">
                    <img src="img/logo_white.png" width="auto" height="80%" alt="Logo" />
                </div>
            </b-link>
            <SidebarToggler class="d-md-down-none hidden" display="lg" />
            <b-navbar-nav class="ml-auto" style="margin-right : 15px;">
                <DefaultHeaderDropdownAccnt />
            </b-navbar-nav>
        </AppHeader>
        <div class="app-body">
            <AppSidebar fixed>
                <SidebarNav class="sidebar_nav" :navItems="nav"></SidebarNav>
            </AppSidebar>
            <main class="main">
                <div class="container-fluid" style="padding: 0;">
                    <router-view></router-view>
                </div>
            </main>
            <AppAside fixed>
            </AppAside>
        </div>
    
        <!--footer-->
        <TheFooter>
            <div class="text-center footer footer-title" style="width: 100%">
                <h5>
                    {{aLang.default_container_footer_header}}
                </h5>
                <p class="phone-email">
                    {{aLang.default_container_footer_phone_number}}:
                    <a style="color: #ffffff" href="tel:0906150276">0906150276</a>; Email:
                    <a style="color: #ffffff" href="mailto:titc@vietnamtourism.gov.vn">titc@vietnamtourism.gov.vn</a>;
                </p>
          </div>
        </TheFooter>
      </div>
</template>

<script>
import MethodService from "../service/MethodService";
import nav from "@/_nav";
import {
    Header as AppHeader,
    SidebarToggler,
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
    Aside as AppAside,
    AsideToggler,
    Footer as TheFooter,
    Breadcrumb,
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
import PhanHoiApi from "../moduleApi/PhanHoiApi";
import ForeignerApi from '../moduleApi/ForeignerApi';
import ForeignerQrApi from '../moduleApi/ForeignerQrApi';
import LanguageService from '../service/LanguageService';

export default {
    name: "DefaultContainer",
    components: {
        AsideToggler,
        AppHeader,
        AppSidebar,
        AppAside,
        TheFooter,
        Breadcrumb,
        DefaultAside,
        DefaultHeaderDropdownAccnt,
        SidebarForm,
        SidebarFooter,
        SidebarToggler,
        SidebarHeader,
        SidebarNav,
        SidebarMinimizer,
    },
    data() {
        return {
            aLang: LanguageService.lang,
            nav: MethodService.copyObject(nav.items),
            navNew: [],
            prevUrl:null,

        };
    },

    computed: {
        name() {
            return this.$route.name;
        },
        list() {
            return this.$route.matched.filter(
                (route) => route.name || route.meta.label
            );
        },
    },
    methods: {
        async fn_countPhanHoi() {
            let currentUser = MethodService.getCurrentUser();
            let res = await PhanHoiApi.countNew(currentUser.id);
            $.each(this.nav, (index, item) => {
                if (item.code == "PhanHoi") {
                    item.badge.text = res.meta.total;
                }
            });
        },

        fn_recountPhanHoi() {
            window.reqIntervalPhanHoi = setInterval(() => {
                this.fn_countPhanHoi();
            }, 900000); //15phut
        },

        async fn_getNav() {
            let currentUser = MethodService.getCurrentUser();
            let arrNav = this.nav;


            $.each(arrNav, (indexNar1, valueNarLever1) => {
                if (
                    valueNarLever1.meta.allowAccess &&
                    valueNarLever1.meta.allowAccess.length > 0
                ) {
                    //check quyền truy cập Nav1
                    $.each(
                        valueNarLever1.meta.allowAccess,
                        (indexMeta1, valueMetaLever1) => {
                            if (
                                currentUser.roles.indexOf(valueMetaLever1) != -1 ||
                                valueMetaLever1 == "*"
                            ) {
                                valueNarLever1.meta.allow = true;
                            }
                        }
                    );
                    //check xem tồn tại Nav2
                    if (valueNarLever1.children && valueNarLever1.children.length > 0) {
                        $.each(valueNarLever1.children, (indexNar2, valueNarLever2) => {
                            if (
                                valueNarLever2.meta.allowAccess &&
                                valueNarLever2.meta.allowAccess.length > 0
                            ) {
                                //check quyền truy cập Nav2
                                $.each(
                                    valueNarLever2.meta.allowAccess,
                                    (indexMeta2, valueMetaLever2) => {
                                        if (
                                            currentUser.roles.indexOf(valueMetaLever2) != -1 ||
                                            valueMetaLever2 == "*"
                                        ) {
                                            valueNarLever2.meta.allow = true;
                                        }
                                    }
                                );
                                //check xem tồn tại Nav3
                                if (
                                    valueNarLever2.children &&
                                    valueNarLever2.children.length > 0
                                ) {
                                    $.each(
                                        valueNarLever2.children,
                                        (indexNar3, valueNarLever3) => {
                                            if (
                                                valueNarLever3.meta.allowAccess &&
                                                valueNarLever3.meta.allowAccess.length > 0
                                            ) {
                                                //check quyền truy cập Nav3
                                                $.each(
                                                    valueNarLever3.meta.allowAccess,
                                                    (indexMeta3, valueMetaLever3) => {
                                                        if (
                                                            currentUser.roles.indexOf(valueMetaLever3) !=
                                                            -1 ||
                                                            valueMetaLever3 == "*"
                                                        ) {
                                                            valueNarLever3.meta.allow = true;
                                                        }
                                                    }
                                                );
                                                //Mở rộng thêm ở đây

                                            }
                                        }
                                    );
                                }
                            }
                        });
                    }
                }
            });
            //Check Lọc quyền Nav1 và trả về mảng đã lọc arrNavFilter
            let arrNavFilter = arrNav.filter(function(value, index, arr) {
                return value.meta.allow == true;
            });
            $.each(arrNavFilter, function(indexNavF1, valueNavF1) {
                //check tồn tại Nav2
                if (valueNavF1.children && valueNavF1.children.length > 0) {
                    // Lọc quyền Nav2 và trả về mảng đã lọc arrNavFilter2
                    let arrNavFilter2 = valueNavF1.children.filter(function(
                        value2,
                        index2,
                        arr2
                    ) {
                        return value2.meta.allow == true;
                    });
                    //gán mảng Nav2 đã lọc vào mảng mẹ
                    valueNavF1.children = arrNavFilter2;
                    $.each(arrNavFilter2.children, function(indexNavF12, valueNavF2) {
                        //check tồn tại Nav3
                        if (valueNavF2.children && valueNavF2.children.length > 0) {
                            // Lọc quyền Nav3 và trả về mảng đã lọc arrNavFilter3
                            var arrNavFilter3 = valueNavF2.children.filter(function(
                                value3,
                                index3,
                                arr3
                            ) {
                                return value3.meta.allow == true;
                            });
                            //gán mảng Nav3 đã lọc vào mảng mẹ
                            valueNavF2.children = arrNavFilter3;
                            // Mở rộng tiếp theo ở đây
                        }
                    });
                }
            });

            if(currentUser.roles.includes("Foreigner")){
                const ForeignerQrApiRes = await ForeignerQrApi.list({
                    filters: "foreigner_id="+currentUser.id
                }) 
                if(ForeignerQrApiRes.result){
                    const URLTest = ['/admin/TravelPassTest'];
                    if(
                        ![
                            "cho_cap_visa",
                            "cho_nhap_visa",
                            "cho_nhap_canh",
                            "da_nhap_canh",
                            "cho_duyet_vaccine"
                        ].includes(ForeignerQrApiRes.result[0].trang_thai)
                    ){
                        const arrNavFilter4 = arrNavFilter.filter(x => URLTest.includes(x.url) == false);
                        arrNavFilter = arrNavFilter4;
                    }
                }
            }
            // Gán mảng mẹ vào Nav Main
            this.nav = arrNavFilter;
        },
        fn_remove(){
            if(document.querySelector('a[href="/admin/TravelPass"] i') && document.getElementsByClassName("fa-globe") ){
                document.querySelector('a[href="/admin/TravelPass"] i').classList.remove("fa-globe","fa");
                document.querySelector('a[href="/admin/TravelPass"] i').classList.add("icon-cus");
            } else if (document.querySelector('a[href="/admin/TravelPassReview"] i') && document.getElementsByClassName("fa-globe") ){
                document.querySelector('a[href="/admin/TravelPassReview"] i').classList.remove("fa-globe","fa");
                document.querySelector('a[href="/admin/TravelPassReview"] i').classList.add("icon-cus");
            }
        },
        fn_addStyle(){
            if(document.getElementsByClassName("icon-cus").length > 0){
                document.getElementsByClassName("icon-cus")[0].style.width = "14px";
                document.getElementsByClassName("icon-cus")[0].style.height = "22px";
                document.getElementsByClassName("icon-cus")[0].style.backgroundImage = "url(/img/certificate_1.png)";
                document.getElementsByClassName("icon-cus")[0].style.marginRight = "10px";
            }
        },
        async fn_checkChangePassword(){
            if(MethodService.checkRole("Foreigner")){
                let checkChangePasswordRes = await ForeignerApi.check_required_change_password();
                if(checkChangePasswordRes.result && checkChangePasswordRes.result.status == true){
                    console.log("checkChangePasswordRes.result",checkChangePasswordRes.result);
                    this.$confirm(
                        "Please change password to secret information!",
                            {
                                confirmButtonText: LanguageService.lang.c_agree,
                                showClose: false,
                                showCancelButton: false,
                                closeOnPressEscape: false,
                                closeOnClickModal: false,
                                closeOnHashChange: false,
                                type: "warning",
                            }
                    )
                    .then(() => {
                        console.log("Router đến màn đổi mật khẩu");
                        this.$router.push("/auth/changepassword");
                    })
                }
            }
        }
    },
    async created() {
        //active route
        if(this.$router.currentRoute.path.indexOf('/admin/DanhGia/')!==-1){
            this.prevUrl = localStorage.getItem('prevUrl');
            this.nav=this.nav.map(item=>{
            if(item.url==this.prevUrl){
                item.class="activeClassRoute"
                return item
            }
            else{
                item.class=null;
                return item;
            }
            })
        }
        else{
            this.nav=this.nav.map(item=>{
                item.class=null;
                return item;
            })

        }
        //end active route
        await this.fn_getNav();
        await this.fn_remove();
        await this.fn_addStyle();
        if (
            MethodService.checkRole("Admin, Officer, TourAgent, TCQLTT, VNATAdmin")
        ) {
            this.fn_countPhanHoi();
            this.fn_recountPhanHoi();
        }
        //xu li active

       
    },
    mouted(){
    },
    beforeUpdate(to,from,next){
        //active route

        if(this.$router.currentRoute.path.indexOf('/admin/DanhGia/')!==-1){
           this.prevUrl = localStorage.getItem('prevUrl');
            this.nav=this.nav.map(item=>{
            if(item.url==this.prevUrl){
                item.class="activeClassRoute"
                return item
            }
            else{
                item.class=null;
                return item;
            }
            })
        }
        else{
            this.nav=this.nav.map(item=>{
                item.class=null;
                return item;
            })
        }
        //End active route

    },
    watch: {
        "$store.state.phanHoi.refreshFnCountNew": function(newVal, oldVal) {
            var _this = this;
            if (newVal && newVal != oldVal) {
                _this.fn_countPhanHoi();
            }
        },
        "$store.state.checkChangePassword": function(newVal, oldVal) { 
            var _this = this;
            if (newVal && newVal != oldVal) {
                _this.fn_checkChangePassword();
            }
        },
        "$store.state.checkStatusForeigner": function(newVal, oldVal) { 
            var _this = this;
            if (newVal && newVal != oldVal) {
                _this.fn_getNav();
            }
        },
        $route(to,from){
        }
    },
};
</script>

<style scoped>
@font-face {
  font-family: UTM-Cafeta;
  src: url(/fonts/UTM_Cafeta.ttf);
}
@font-face {
  font-family: MYRIADPRO-REGULAR;
  src: url(/fonts/MYRIADPRO-REGULAR.OTF);
}
::v-deep .app-body{
    overflow-x: unset;
}
.icon-cus{
    background-image: url();
}
.activeClassRoute {
    color: #fff !important;
    background: #293846; 
    border-left: 4px solid #19aa8d;
}
.app-header .navbar-brand{
    width: 710px;
}
.navbar-brand-full{
    display: flex;
    align-items: center;
}
.navbar-brand-full img{
    margin-right: 10px;
}
.navbar-brand-full p{
    margin-bottom: 0;
}
.navbar-brand-full .title{
    color: #fff;
    padding-right: 10px;
    border-right: 1px solid #25b8ec;
}
.navbar-brand-full .title .mcst{
    font-size: 9.11px;
    letter-spacing: 1.56px;
}
.navbar-brand-full .title .vnat{
    font-size: 11.06px;
}
.certificate{
    margin-left: 10px;
    display: flex;
    align-items: center;
}
.certificate .certificate-title .text{
    font-family: UTM-Cafeta;
    color: #ffffff;
    text-transform: uppercase;
    font-size: 25px;
}
.sidebar{
    background: #e8eef2; 
    width: 275px;
}
.sidebar .sidebar-nav{
    width: 275px;
}
.footer-title h5{
    color: #ade0eb;
    margin-bottom: 0px;
    font-family: MYRIADPRO-REGULAR;
    font-size: 16px;
}
.footer-title .phone-email{
    color: white;
    margin-bottom: 0px;
    font-family: MYRIADPRO-REGULAR;
    font-size: 13px;
}
::v-deep .sidebar .nav{
    width: 275px;
}
::v-deep .sidebar .nav-link{
    display: flex;
    align-items: center;
    font-size: 13px;
    border-left: none;
    border-bottom: 1px solid #88d5f1;
    color: #0c66ad !important;
    font-weight: 700;
}
::v-deep .sidebar .nav-link:hover{
    background: #ade0eb;
}
::v-deep .sidebar .nav-link.active{
    display: flex;
    align-items: center;
    background: #ade0eb; 
    border-left: none;
    border-bottom: 1px solid #25b8ec;
    color: #0c66ad !important;
    font-weight: 700;
}
::v-deep .app-header{
    background-color: #0c66ad;
    height: 60px;
}
::v-deep .app-footer {
    margin-left: 0 !important;
    padding: 0 !important;
    background-color: #0c66ad;
    position: sticky;
    bottom: 0;
    z-index: 10;
}

@media (min-width: 992px) {
    ::v-deep .app-body .sidebar {
        height: calc(100vh - 110px) !important;
    }
    .main{
        margin-left: 275px !important;
    }
    html:not([dir="rtl"]) .sidebar {
        margin-left: -275px;
    }
    .header-fixed .app-body {
        margin-top: 60px;
    }
}
@media (min-width: 991.98px){
    html:not([dir="rtl"]) .sidebar {
        margin-left: 0px;
    }
}

@media (min-width: 576px) and (max-width: 991.98px) {
    .app-body{
        margin-top: 60px;
    }
    .app-header .navbar-brand{
        width: 500px;
    }
    .certificate{
        display: none;
    }
    .app-header .navbar-brand{
        top:5px;
    }
    .navbar-brand-full .title{
        border-right: none;
    }
    ::v-deep .app-footer {
        position: relative;
    }
    ::v-deep .sidebar {
        position: fixed;
        z-index: 1019;
        height: calc(100vh - 110px) !important;
    }
    html:not([dir="rtl"]) .sidebar {
        margin-left: -275px;
    }
    html:not([dir="rtl"]) .sidebar-show .sidebar, html:not([dir="rtl"]) .sidebar-show .sidebar{
        margin-left: 0px;
    }
    html:not([dir="rtl"]) .sidebar-show.sidebar-fixed .main{
        margin-left: 275px;
    }

}
@media (max-width: 576px) {
    .main{
        margin-top: 10px;
    }
    html:not([dir="rtl"]) .sidebar {
        margin-top: 10px;
        margin-left: -275px;
    }
    html:not([dir="rtl"]) .sidebar-show .sidebar, html:not([dir="rtl"]) .sidebar-show .sidebar{
        margin-left: 0px;
        margin-top: 10px;
    }
}
@media (max-width: 767px) {
    ::v-deep .sidebar {
        position: fixed;
        z-index: 1019;
        height: calc(100vh - 56px);
    }
    .footer h5{
        font-size: 14px;
    }
    .app-header .navbar-brand{
        width: 100px;
    }
    .footer p{
        font-size: 12px;
    }
}
@media (max-width: 415px) {
    .footer h5{
        font-size: 11px;
    }
    .footer-title .phone-email{
        font-size: 9px;
    }
}
</style>
<style>
@media (max-width: 436px){
  .el-message-box{
    width: 350px;
  }
}
@media (max-width: 352px){
  .el-message-box{
    width: 310px;
  }
}
@media (max-width: 330px){
    .app-header .navbar-nav .dropdown-menu-right{
        right: -5px;
    }
}

</style>